// RouteDaily.js
import React, { useState } from 'react';
import { Box } from '@mui/system';
import { Button, Tabs, Tab, AppBar, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { styled } from '@mui/material/styles';
import useClientSize from '../hook/useClientSize';
import RouteDailyList from './RouteDailyList';
import RouteDailySingleList from './RouteDailySingleList';
import VehItinDailyList from '../veh_itin/VehItinDailyList';
import VehRouteListMini from '../veh_route/VehRouteListMini';
import { AppNumber } from '../../model/AppConst';

const dcPad = AppNumber.dataContainerPadding;
const RouteDailyContainer = styled(Box)({
	position:"absolute", top:dcPad, right:dcPad, bottom: dcPad, left: dcPad,
});

// 각 목록을 숨기거나 보이게 하기 위해서 (diaplay: 'flex' or 'none')
const ListWrapper = styled(Box)({
    position:"absolute", top:0, right:0, bottom: 0, left: 0,
});

const RouteContainer = styled(Box)({
    position:'relative'
});

const RouteDailyView = {ByDate:1, OneDay:2, ItinDaily:3};

export default function RouteDaily() {
    const [viewNow, setViewNow] = useState(RouteDailyView.ByDate);
    const [durationRoute, setDurationRoute] = useState(null);
    const [vehPlates, setVehPlates] = useState('');
    const clientSize = useClientSize();

    const onClickViewTab = (event, value) => {        
        setViewNow(value);
    };

    const onRequestPopRoute = (vehInfo, timeFrom, timeTill) => {
        setVehPlates(vehInfo.vehPlates);
        setDurationRoute({...vehInfo, from:timeFrom, till:timeTill});
    };

    const AppSelector =
        <AppBar position="static" color='default'
            style={{boxShadow:'none'}}
        >
            <Tabs value={viewNow} onChange={onClickViewTab}
                scrollButtons="auto"
                variant='fullWidth' textColor="inherit"
                indicatorColor="primary"
            >
                <Tab value={RouteDailyView.ByDate} label="일자별 주행거리" />
                <Tab value={RouteDailyView.OneDay} label="1일 주행거리" />
                <Tab value={RouteDailyView.ItinDaily} label="하루 전체차량 동정정보 조회" />
            </Tabs>
        </AppBar>;

    const dialogWidth = clientSize.dataAreaWidth > 1000 ? 1000 : clientSize.dataAreaWidth * 0.8;
	// AppMain.js의 resize에 따라 창을 채우는 고정된 높이를 갖는 <ContentContainer> 안에 놓임.
    return (
        <RouteDailyContainer>
            <ListWrapper style={{display: viewNow===RouteDailyView.ByDate ? 'flex' : 'none'}}>
                <RouteDailyList
                    maxHeight={clientSize.dataAreaHeight}
                    maxWidth={clientSize.dataAreaWidth - dcPad * 2}
                    tabSelector={AppSelector}
                />
            </ListWrapper>
            <ListWrapper style={{display: viewNow===RouteDailyView.OneDay ? 'flex' : 'none'}}>
                <RouteDailySingleList
                    maxHeight={clientSize.dataAreaHeight}
                    maxWidth={clientSize.dataAreaWidth - dcPad * 2}
                    tabSelector={AppSelector}
                />
            </ListWrapper>
            <ListWrapper style={{display: viewNow===RouteDailyView.ItinDaily ? 'flex' : 'none'}}>
                <VehItinDailyList
                    maxHeight={clientSize.dataAreaHeight}
                    maxWidth={clientSize.dataAreaWidth - dcPad * 2}
                    tabSelector={AppSelector}
                    onRequestViewRoute={onRequestPopRoute}
                />
            </ListWrapper>
            <Dialog open={Boolean(durationRoute)}
                onClose={()=>{setDurationRoute(null)}}
                maxWidth="lg"
            >
                <DialogTitle>
                    {vehPlates} 이동경로
                </DialogTitle>
                <DialogContent style={{minWidth:dialogWidth}}>
                    <RouteContainer height={clientSize.dataAreaHeight-50 - 200}>
                        <VehRouteListMini
                            vehPos={durationRoute}
                            durationGiven={durationRoute}
                            maxHeight={clientSize.dataAreaHeight-50 - 20}
                            maxWidth={clientSize.dataAreaWidth - dcPad * 3 - 160}
                        />
                    </RouteContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{setDurationRoute(null)}} variant='contained'>닫기</Button>
                </DialogActions>
            </Dialog>
        </RouteDailyContainer>
    )
}
